import { useState } from 'react';
import { H0 } from '@bigcommerce/big-design';
import './CallCenterPage.css';
import {
	CustomerInfoSection,
	ItemsInOrderSection,
	OrderSummarySection,
	ProductsSearchSection,
} from './components/Sections';
import CustomerSearch from './components/Sections/CustomerInfoSection/CustomerSearch';
import {
	CurrencyProvider,
	CustomerGroupAndProductTypesProvider,
	CustomerGroupProvider,
	OrderProductsProvider,
} from './context';
import useOrderProductsStore from './store/orderProducts';

// Figure out which custom product fields are required.
export function CallCenterPage() {
	const [orderProducts, dispatchOrderProducts] = useOrderProductsStore();
	const [customer, setCustomer] = useState({});
	return (
		<CurrencyProvider>
			<CustomerGroupAndProductTypesProvider selectedCustomer={customer}>
				<CustomerGroupProvider>
					<OrderProductsProvider
						value={[orderProducts, dispatchOrderProducts]}
					>
						<CustomerSearch
							selectedCustomer={customer}
							onSelectCustomer={setCustomer}
						/>
						<H0 as="h1" className="page-title" marginTop="xxxLarge">
							New Order Form
						</H0>
						<CustomerInfoSection
							customer={customer}
							setCustomer={setCustomer}
						/>
						<ProductsSearchSection />
						<ItemsInOrderSection />
						<OrderSummarySection
							customer={customer}
							products={orderProducts}
						/>
					</OrderProductsProvider>
				</CustomerGroupProvider>
			</CustomerGroupAndProductTypesProvider>
		</CurrencyProvider>
	);
}
